import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsDistribution,
  useMetricsPatterns,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsFilters,
  MetricsPatternsParams,
} from "../../../../../shared/api/types";

export const useSleepStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || [
      "sleep_performance",
      "sleep_consistency",
      "sleep_efficiency",
      "high_sleep_stress",
    ],
  });
};

export const useSleepTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || [
      "sleep_efficiency",
      "sleep_debt",
      "sleep_stress",
      "sleep_stage_awake",
      "sleep_stage_light",
      "sleep_stage_rem",
      "sleep_stage_deep",
    ],
    granularity: params?.granularity || "daily",
  });
};

export const useSleepStageDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "sleep_stage_distribution",
  });
};

export const useSleepPatterns = (params: MetricsPatternsParams) => {
  return useMetricsPatterns(params);
};

